import * as React from "react";
import { AirMeltCategoryInfo } from "../air-melt";
import { AirMeltCategory } from "../core/alloy-types";
import { VacuumCategoryInfo } from "../vacuum";
import { Checkbox, FormControlLabel } from "@mui/material";

require("./styles.scss");

interface SelectCategoryUIProps {
  categoryOptions: any[];
  setCategories: (category: AirMeltCategoryInfo | VacuumCategoryInfo) => void;
}

export class SelectCategoryUI extends React.PureComponent<
  SelectCategoryUIProps,
  {}
> {
  render() {
    let buttons = this.props.categoryOptions.map(
      (c: VacuumCategoryInfo | AirMeltCategoryInfo, i) => {
        if (c.value !== AirMeltCategory.CarbonAndLowAlloySteels) {
          return (
            <div key={c.value}>
              <FormControlLabel
                control={<Checkbox/>}
                label={c.value}
                key={i}
                checked={c.selected}
                onClick={(e) => { e.preventDefault(); this.props.setCategories(c)}}
              />
            </div>
          );
        } else {
          return null;
        }
      }
    );

    return (
      <div className="selector-group--categories product-type-selector">
        {buttons}
      </div>
    );
  }
}
